export function parseNumber(value) {
    return (value && 1 * value.replace(/\D/g, "")) || 0;
}

export function formatNumber(value) {
    value = parseNumber(value);
    return `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, " ");
}